<template>
  <v-container fluid>
    <v-layout justify-space-between align-center>
      <h2>{{ $tt('customFieldsList') }}</h2>
      <field-sort-order-component />
    </v-layout>
    <v-row :class="{ 'justify-center': isMobile, 'justify-start': !isMobile }" v-if="fields.length > 0">
      <v-card v-for="f in fields" :key="f.id" class="d-flex  ma-2" flat tile>
        <v-card hover link :width="thumbnailSize">
          <div>
            <v-img
              :src="calculateStaticThumbnailUrl(f)"
              aspect-ratio="1"
              :height="thumbnailSize"
              @click="showDetail(f)"
              style="position: relative;"
            />
            <div class="d-flex justify-space-between pa-1" style="position: absolute; top: 0; left: 0; width: 100%;">
              <user-icon-component
                size="36"
                :showNickname="true"
                :iconUrl="getAccount(f).iconUrl"
                :nickname="getAccount(f).nickname"
              />
              <v-btn
                color="error"
                fab
                x-small
                v-if="isMyField(f)"
                tile
                @click="$refs.deleteDialog.openDeleteFieldDialog(f)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </div>
          </div>

          <v-card-text class="text--primary" @click="showDetail(f)">
            <div class="subtitle-1 ">
              {{ f.name }}
            </div>
            <div class="body-2">
              <span class="font-weight-bold mr-1" v-html="$options.filters.aidAreaText(f.area, true)" />
            </div>
            <v-list style="background: none">
              <v-list-item-subtitle>
                <div v-for="p in listCurrentPlantings(f)">
                  <planting-indicator-component :planting="p" small :display-year="false" />
                </div>
              </v-list-item-subtitle>
            </v-list>
          </v-card-text>
        </v-card>
      </v-card>
    </v-row>
    <v-row v-else justify="center" align-content="center">
      <v-col cols="8" class="pt-12">
        <v-img class="img-fluid" src="/images/fields_list_no_fields.jpg" />
      </v-col>
    </v-row>

    <field-delete-dialog-component ref="deleteDialog" />
    <pagination-component
      :pagination-info="paginationInfo"
      :paging-type="pagingType"
      @update-paging="updatePaging($event)"
    />
  </v-container>
</template>

<script>
import FieldDeleteDialogComponent from '@/components/fields/FieldDeleteDialogComponent'
import FieldSortOrderComponent from '@/components/fields/FieldSortOrderComponent'
import FieldListMixin from '@/components/mixins/field-list-mixin'
import PaginationComponent from '@/components/PaginationComponent'
import PlantingIndicatorComponent from '@/components/planting/PlantingIndicatorComponent'
import UserIconComponent from '@/components/user/UserIconComponent'
import * as Constants from '@/lib/constants'

export default {
  name: 'FieldListAsCard',
  components: {
    PlantingIndicatorComponent,
    UserIconComponent,
    FieldDeleteDialogComponent,
    PaginationComponent,
    FieldSortOrderComponent,
  },
  mixins: [FieldListMixin],
  data: () => ({
    thumbnailSize: Constants.FIELD_CARD_THUMBNAIL_SIZE,
    isMobile: false,
  }),
}
</script>
